import React, { memo } from 'react';
export const BonusSection = memo(function BonusSection() {
  const bonuses = [{
    id: 1,
    icon: '🎁',
    title: 'Kit "Cero Miedo"',
    subtitle: '25 ejercicios prácticos para ganar confianza real en 7 días',
    desc: 'Cerrá la brecha entre la teoría y la acción. 25 pruebas guiadas con checklist y registro de progreso para que arranques sin dudar.',
    value: '$9.900'
  }, {
    id: 2,
    icon: '📋',
    title: 'Plantillas "Presupuesto que Cierra"',
    subtitle: '12 modelos listos + Scripts de WhatsApp para cobrar sin dudar',
    desc: '12 plantillas para los servicios más pedidos y 8 scripts de WhatsApp para cerrar presupuestos y pedir seña como un profesional.',
    value: '$7.900'
  }, {
    id: 3,
    icon: '✅',
    title: 'Checklist "Casa Segura"',
    subtitle: 'Auditá cualquier instalación en 30 minutos antes de que pase algo',
    desc: 'Detectá los 20 riesgos eléctricos más comunes en hogares argentinos con un semáforo de urgencias y plantilla de informe lista para entregar.',
    value: '$6.900'
  }, {
    id: 4,
    icon: '🔨',
    title: 'Guía "Herramientas Inteligentes"',
    subtitle: 'Qué comprar primero y qué NO comprar en Argentina',
    desc: 'Armá tu kit profesional sin gastar de más. Checklist por nivel y guía de evaluación para MercadoLibre incluidos.',
    value: '$5.900'
  }];
  // Duplicamos el array para el loop infinito
  const infiniteBonuses = [...bonuses, ...bonuses, ...bonuses];
  return <section className="py-16 bg-gray-950 border-t border-gray-800 overflow-hidden" data-id="element-19">
      {/* Keyframes para el scroll infinito */}
      <style data-id="element-20">{`
        @keyframes scrollLeft {
          0%   { transform: translateX(0); }
          100% { transform: translateX(-33.333%); }
        }
        .animate-scroll-left {
          animation: scrollLeft 40s linear infinite;
          width: max-content;
        }
        .animate-scroll-left {
          pointer-events: none;
        }
      `}</style>

      <div className="max-w-5xl mx-auto px-4" data-id="element-21">
        {/* Header */}
        <div className="text-center mb-12" data-id="element-22">
          <div className="inline-block bg-amber-500/20 text-amber-500 px-5 py-1.5 rounded-full font-black text-[11px] uppercase tracking-widest mb-4 border border-amber-500/30" data-id="element-23">
            🎁 BONOS EXCLUSIVOS
          </div>
          <h2 className="text-[24px] md:text-4xl font-black text-white mb-4 leading-tight max-w-3xl mx-auto" data-id="element-24">
            Con tu Megapack Eléctrico PRO recibís{' '}
            <span className="text-amber-500" data-id="element-25">
              4 Bonos Exclusivos sin costo adicional:
            </span>
          </h2>
        </div>
      </div>

      {/* Carrusel Infinito */}
      <div className="relative w-full overflow-hidden" data-id="element-26">
        {/* Fade izquierda */}
        <div className="absolute left-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-r from-gray-950 to-transparent z-10 pointer-events-none" data-id="element-27" />
        {/* Fade derecha */}
        <div className="absolute right-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-l from-gray-950 to-transparent z-10 pointer-events-none" data-id="element-28" />

        <div className="animate-scroll-left flex gap-5 py-4 px-4" data-id="element-29">
          {infiniteBonuses.map((bono, index) => <div key={index} className="flex-shrink-0 w-[280px] md:w-[320px] bg-gray-900 rounded-2xl border border-amber-500/30 p-6 shadow-xl flex flex-col relative overflow-hidden" data-id="element-30">
              {/* Ribbon */}
              <div className="absolute top-0 right-0 bg-amber-500 text-gray-900 text-[10px] font-black uppercase tracking-widest px-4 py-1 rounded-bl-lg" data-id="element-31">
                Bono #{bono.id}
              </div>

              {/* Header */}
              <div className="mb-4 pr-16" data-id="element-32">
                <div className="flex items-center gap-3 mb-2" data-id="element-33">
                  <span className="text-3xl" data-id="element-34">{bono.icon}</span>
                  <h3 className="text-[16px] font-black text-white leading-tight" data-id="element-35">
                    {bono.title}
                  </h3>
                </div>
                <p className="text-amber-500 font-bold text-[12px] leading-snug mt-2" data-id="element-36">
                  "{bono.subtitle}"
                </p>
              </div>

              {/* Desc */}
              <p className="text-gray-400 text-[12px] leading-relaxed mb-5 flex-1" data-id="element-37">
                {bono.desc}
              </p>

              {/* Valor */}
              <div className="flex items-center justify-between bg-gray-950 p-3 rounded-xl border border-gray-800 mt-auto" data-id="element-38">
                <span className="text-gray-500 text-[11px] font-bold uppercase tracking-wider" data-id="element-39">
                  Valor Real: <span className="line-through" data-id="element-40">{bono.value}</span>
                </span>
                <span className="text-green-400 font-black text-[12px] uppercase tracking-wider" data-id="element-41">
                  INCLUIDO
                </span>
              </div>
            </div>)}
        </div>
      </div>

      {/* Resumen de Bonos */}
      <div className="max-w-2xl mx-auto px-4 mt-12" data-id="element-42">
        <div className="bg-gray-900 border border-gray-700 rounded-2xl overflow-hidden shadow-2xl" data-id="element-43">
          <div className="bg-gray-800 p-4 border-b border-gray-700 text-center" data-id="element-44">
            <h3 className="text-white font-black text-lg uppercase tracking-wider" data-id="element-45">
              Resumen de Bonos
            </h3>
          </div>
          <div className="p-6" data-id="element-46">
            <div className="space-y-3 mb-6" data-id="element-47">
              {[{
              name: 'Bono 1: Kit Cero Miedo',
              val: '$9.900'
            }, {
              name: 'Bono 2: Plantillas Presupuesto',
              val: '$7.900'
            }, {
              name: 'Bono 3: Checklist Casa Segura',
              val: '$6.900'
            }, {
              name: 'Bono 4: Guía Herramientas Inteligentes',
              val: '$5.900'
            }].map((item, i) => <div key={i} className="flex justify-between items-center text-[13px] md:text-sm border-b border-gray-800 pb-2" data-id="element-48">
                  <span className="text-gray-300" data-id="element-49">{item.name}</span>
                  <span className="text-gray-500 line-through" data-id="element-50">{item.val}</span>
                </div>)}
            </div>

            <div className="flex justify-between items-center text-[14px] md:text-base mb-2" data-id="element-51">
              <span className="text-gray-400 font-bold" data-id="element-52">Total en Bonos</span>
              <span className="text-red-400 font-bold line-through" data-id="element-53">
                $30.600 ARS
              </span>
            </div>

            <div className="bg-green-500/10 p-5 rounded-xl border border-green-500/30 mt-4 text-center" data-id="element-54">
              <span className="block text-green-400/80 font-bold text-[13px] md:text-sm uppercase tracking-wider mb-1" data-id="element-55">
                Con tu Megapack Eléctrico PRO hoy
              </span>
              <span className="block text-green-400 font-black text-[28px] md:text-3xl" data-id="element-56">
                $0 ARS
              </span>
              <span className="block text-green-400/60 text-[11px] mt-1 font-medium" data-id="element-57">
                Todos los bonos incluidos sin costo extra
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
});